import React, { useState } from "react";
import { MapPin, Phone, Mail, Send, CheckCircle, Navigation } from "lucide-react";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="bg-[#FDFCF8] min-h-screen pt-8 pb-12 overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        <div className="text-center mb-8">
          <span className="text-[9px] font-black uppercase tracking-[0.5em] text-[#D4AF37] block mb-2">
            Get In Touch
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-[#4B3621] tracking-tighter">
            Inquiry <span className="text-[#2D5A27]">Portal.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start mb-12">
          
          <div className="space-y-4">
            <h3 className="text-lg font-black text-[#4B3621] tracking-tight mb-4 italic px-2">
              Direct Contacts
            </h3>
            {[
              { icon: <Phone size={18} />, label: "Call Us", val: "+91 77299 83005", color: "text-[#2D5A27]" },
              { icon: <Mail size={18} />, label: "Email", val: "contact@gurufarms.com", color: "text-[#D4AF37]" },
              { icon: <MapPin size={18} />, label: "Location", val: "Bommanapalli, Gangavaram, Palamaner, AP 517408", color: "text-[#2D5A27]" }
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-4 p-4 bg-white rounded-2xl border border-gray-100 shadow-sm">
                <div className={`${item.color}`}>{item.icon}</div>
                <div>
                  <p className="text-[8px] font-black uppercase tracking-widest text-gray-400 mb-0.5">{item.label}</p>
                  <p className="text-sm font-bold text-[#4B3621]">{item.val}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-50 relative overflow-hidden">
            {submitted ? (
              <div className="flex flex-col items-center justify-center py-12 text-center space-y-3 animate-in fade-in zoom-in">
                <CheckCircle size={48} className="text-[#2D5A27]" />
                <h4 className="text-xl font-black text-[#4B3621]">Message Received</h4>
                <p className="text-xs text-gray-500">Our compliance officer will contact you shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="text-[9px] font-black uppercase tracking-widest text-[#D4AF37] ml-1">Full Name</label>
                  <input required type="text" placeholder="e.g., John Doe" className="w-full mt-1 p-3 bg-[#FDFCF8] border border-gray-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2D5A27] transition-all" />
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-[9px] font-black uppercase tracking-widest text-[#D4AF37] ml-1">Email Address</label>
                    <input required type="email" placeholder="mail@example.com" className="w-full mt-1 p-3 bg-[#FDFCF8] border border-gray-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2D5A27]" />
                  </div>
                  <div>
                    <label className="text-[9px] font-black uppercase tracking-widest text-[#D4AF37] ml-1">Phone Number</label>
                    <input required type="tel" placeholder="+91 ..." className="w-full mt-1 p-3 bg-[#FDFCF8] border border-gray-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2D5A27]" />
                  </div>
                </div>

                <div>
                  <label className="text-[9px] font-black uppercase tracking-widest text-[#D4AF37] ml-1">Your Message</label>
                  <textarea required rows="3" placeholder="Describe your inquiry..." className="w-full mt-1 p-3 bg-[#FDFCF8] border border-gray-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2D5A27] resize-none"></textarea>
                </div>

                <button type="submit" className="w-full bg-[#2D5A27] text-white font-black uppercase tracking-[0.2em] py-4 rounded-xl flex items-center justify-center gap-3 hover:bg-[#4B3621] transition-all shadow-md group text-[10px]">
                  Submit Inquiry <Send size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="mt-8 bg-white p-4 rounded-3xl shadow-lg border border-gray-50">
          <div className="flex flex-col md:flex-row justify-between items-center mb-4 px-2">
            <div>
              <h3 className="text-xl font-black text-[#4B3621] tracking-tight">Visit Our Farm</h3>
              <p className="text-xs text-gray-500 font-medium">Find us in Palamaner</p>
            </div>
            <a 
              href="https://maps.google.com/?cid=6678861094179557996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNl" 
              target="_blank" 
              rel="noreferrer"
              className="mt-4 md:mt-0 flex items-center gap-2 bg-[#FDFCF8] px-4 py-2 rounded-xl border border-gray-200 text-[#2D5A27] font-bold text-xs hover:bg-[#2D5A27] hover:text-white transition-all shadow-sm"
            >
              Get Directions <Navigation size={14} />
            </a>
          </div>
          
          <div className="w-full h-[400px] rounded-2xl overflow-hidden border border-gray-100">
            <iframe
              title="Gurus Sheep and Goat Farms Map"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.992215682054!2d78.76054197576208!3d13.227890287110196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb17daf1d0a6a0b%3A0x5cb0141b6ecbb76c!2sGurus%20Sheep%20and%20Goat%20Farms!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}